export default __webpack_public_path__ + "static/825-c838384ca817deaa3563009ab31f117e.gif";